"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplierTestResult = void 0;
const typeorm_1 = require("typeorm");
// eslint-disable-next-line import/no-cycle
const SupplierTestAttachment_1 = require("./SupplierTestAttachment");
const TestResultState_1 = require("./TestResultState");
const JournaledEntity_1 = require("../../JournaledEntity");
const CircularReference_1 = require("../../serialization/CircularReference");
let SupplierTestResult = class SupplierTestResult extends JournaledEntity_1.JournaledEntity {
    constructor(init) {
        super();
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.SupplierTestResult = SupplierTestResult;
__decorate([
    (0, typeorm_1.OneToOne)(() => SupplierTestAttachment_1.SupplierTestAttachment, (a) => a.result),
    (0, typeorm_1.JoinColumn)(),
    (0, CircularReference_1.CircularRef)(),
    __metadata("design:type", SupplierTestAttachment_1.SupplierTestAttachment)
], SupplierTestResult.prototype, "test", void 0);
__decorate([
    (0, typeorm_1.RelationId)((r) => r.test),
    __metadata("design:type", String)
], SupplierTestResult.prototype, "testId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => TestResultState_1.TestResultState),
    __metadata("design:type", TestResultState_1.TestResultState)
], SupplierTestResult.prototype, "resultState", void 0);
__decorate([
    (0, typeorm_1.RelationId)((r) => r.resultState),
    __metadata("design:type", String)
], SupplierTestResult.prototype, "resultStateId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], SupplierTestResult.prototype, "resultContent", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], SupplierTestResult.prototype, "comment", void 0);
exports.SupplierTestResult = SupplierTestResult = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], SupplierTestResult);
